import { createSlice } from "@reduxjs/toolkit";
import { persistor } from "../store";

const initialState = {
  isLoggedIn: false,
  userData: {
    permissions: [],
  },
};
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(state, action) {
      state.isLoggedIn = true;
      state.userData = action?.payload?.userData;
      let expiryTime = Date.now() + 24 * 60 * 60 * 1000;
      if (action?.payload?.rememberMe === true) {
        expiryTime = Date.now() + 7 * 24 * 60 * 60 * 1000;
      }

      state.userData.expireTime = expiryTime;
    },
    logout(state) {
      console.log("logout");
      localStorage.removeItem("persist:root");
      state.isLoggedIn = false;
      state.userData = {};
    },
    changeLocation(state, action) {
      console.log("changeLocation", action);
      state.userData.selectedLocationCode = action?.payload;
    },

    changeCompany(state, action) {
      console.log("changeCompany", action);
      state.userData = {
        ...state.userData,
        ...action?.payload?.companyDetails,
        companyDetails: action?.payload?.companyDetails,
        isAllCompanies: false,
        selectedCompanyCode: action?.payload?.companyDetails?.companyCode,
      };
      // state.userData.companyCode = action?.payload?.companyCode;
      // state.userData.companyName = action?.payload?.companyName;
    },

    changeToAllCompany(state, action) {
      console.log("changeCompany", action);
      state.userData = {
        ...state.userData,
        // ...action?.payload,
        isAllCompanies: true,
        selectedCompanyCode: 0,
      };
      // state.userData.companyCode = action?.payload?.companyCode;
      // state.userData.companyName = action?.payload?.companyName;
    },

    setPermissions: (state, action) => {
      state.permissions = action.payload.permissions || [];
    },
  },
});

export const {
  login,
  logout,
  changeLocation,
  changeCompany,
  changeToAllCompany,
} = authSlice.actions;
export const selectIsLoggedIn = (state) => state.auth.isLoggedIn;
export const loggedInUser = (state) => state.auth.userData;
export const getToken = (state) => state.auth.userData.token;
export const authReducer = authSlice.reducer;
export { initialState };
